/**
 * Phone number formatting utilities
 */

/**
 * Format phone number as user types (US format)
 * Converts input like "5551234567" to "(555) 123-4567"
 */
export function formatPhoneNumber(value: string): string {
  // Remove all non-digit characters
  const digits = value.replace(/\D/g, '');
  
  // Limit to 10 digits
  const limitedDigits = digits.substring(0, 10);
  
  // Format based on length
  if (limitedDigits.length === 0) {
    return '';
  } else if (limitedDigits.length <= 3) {
    return `(${limitedDigits}`;
  } else if (limitedDigits.length <= 6) {
    return `(${limitedDigits.substring(0, 3)}) ${limitedDigits.substring(3)}`;
  } else {
    return `(${limitedDigits.substring(0, 3)}) ${limitedDigits.substring(3, 6)}-${limitedDigits.substring(6)}`;
  }
}

/**
 * Strip formatting from phone number for API submission
 * Converts "(555) 123-4567" to "5551234567"
 */
export function stripPhoneFormatting(value: string): string {
  return value.replace(/\D/g, '');
}

/**
 * Validate US phone number format
 */
export function isValidPhoneNumber(value: string): boolean {
  const digits = stripPhoneFormatting(value);
  return digits.length === 10;
}

/**
 * Format phone number for display (with +1 prefix)
 * Converts "5551234567" to "+1-555-123-4567"
 */
export function formatPhoneForDisplay(value: string): string {
  const digits = stripPhoneFormatting(value);
  if (digits.length !== 10) {
    return value;
  }
  
  return `+1-${digits.substring(0, 3)}-${digits.substring(3, 6)}-${digits.substring(6)}`;
}